export class SwitchPortConfiguration {
    port: number;
    label: string;
    comments: string;
    untaggedLogicalNetworkId: number;
    taggedLogicalNetworkIds: number[];
    poe_enabled: boolean;
    mgmt_port: boolean;
    enabled: boolean;
}
